import {
  Grid,
  Button,
  Paper,
  Tooltip,
  Container,
  CircularProgress,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { Multiselect } from "./MultiSelectDropdown";
import { useStore } from "../store/Store";
import { createPublication } from "../restAPI/v1/Publications";
import {
  searchPublicationById,
  updatePublication,
  deletePublication,
} from "../restAPI/v1/Publications";

interface State {
  params: string;
}
const multiselectDesign = {
  searchBox: {
    minHeight: "50px",
  },
  chips: {
    background: "#28a745",
    fontSize: "12px",
  },
  option: {
    color: "black",
  },
};

const Publication = (props: any) => {
  const { dispatch, state } = useStore();
  const [localState, setLocalState] = React.useState<State>({
    params: props.match.params[0],
  });
  const [publicationData, setPublicationData] = useState<System.Publication>({
    id: 0,
    title: "",
    authors: "",
    journal: "",
    editors: "",
    publisher: "",
    publisher_place: "",
    year: 0,
    volume: 0,
    pages: "",
    doi: "",
    no: 0,
    book_tags_models: [],
    allKeywords: [],
  });
  const [isDeleting, setIsDeleting] = React.useState(false);

  const thisDeletePublication = (id: any) => {
    setIsDeleting(true);
    deletePublication({ id: id }).then(() => {
      setIsDeleting(false);
      dispatch({
        type: "SET_MODAL_PROPS",
        modalProps: {
          open: true,
          title: "Publication deleted",
          btn1Text: "",
          btn1Color: "primary",
          btn2Text: "Close",
          btn2Color: "default",
          text: "Publication was deleted successfully",
          shouldRedirect: false,
          btn2OnClick: async (inputs: System.ModalInputs) => {
            window.location.href = "/";
          },
        },
      });
    });
  };

  const thisSearch = async () => {
    searchPublicationById(parseInt(localState.params)).then((res) => {
      let tags: {
        tag_id: number;
        tag_name: string;
        tag_type_name: string;
      }[] = [];
      res.data.book_tags_models &&
        res.data.book_tags_models.forEach((tag: any) => {
          tags.push({
            tag_id: tag.id_tag,
            tag_name: tag.tags_model.name,
            tag_type_name: "",
          });
        });
      res.data.book_tags_models = tags;
      setPublicationData(res.data);
    });
  };

  useEffect(() => {
    setLocalState({ ...localState, params: props.match.params[0] });
    props.match.params[0] === "add"
      ? setPublicationData({
          id: 0,
          title: "",
          authors: "",
          journal: "",
          editors: "",
          publisher: "",
          publisher_place: "",
          year: 0,
          volume: 0,
          pages: "",
          doi: "",
          no: 0,
          book_tags_models: [],
          allKeywords: [],
        })
      : thisSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.match.params[0]]);

  const handleInputChange = (
    event: React.ChangeEvent<{ name: string; value: any }>
  ) => {
    setPublicationData({
      ...publicationData,
      [event.target.name]: event.target.value,
    });
  };

  const onChangeDropdownList = (selectedList: any) => {
    setPublicationData({ ...publicationData, book_tags_models: selectedList });
  };

  const submit = async () => {
    try {
      if (localState.params === "add") {
        //create
        createPublication(publicationData).then((res) => {
          if (res.data) {
            dispatch({
              type: "SET_MODAL_PROPS",
              modalProps: {
                open: true,
                title: "Publication inserted",
                btn1Text: "",
                btn1Color: "primary",
                btn2Text: "Close",
                btn2Color: "default",
                text: "Publication was inserted successfully",
                shouldRedirect: false,
                btn2OnClick: async (inputs: System.ModalInputs) => {
                  window.location.href = "/";
                },
              },
            });
          }
        });
      } else {
        //update
        updatePublication(publicationData).then((res) => {
          if (res.data) {
            dispatch({
              type: "SET_MODAL_PROPS",
              modalProps: {
                open: true,
                title: "Publication updated",
                btn1Text: "",
                btn1Color: "primary",
                btn2Text: "Close",
                btn2Color: "default",
                text: "Publications updated successfully",
                shouldRedirect: false,
                btn2OnClick: async (inputs: System.ModalInputs) => {
                  window.location.href = "/";
                },
              },
            });
          }
        });
      }
    } catch (err) {
      console.log(err);
      return;
    }
  };
  if (!state.user.isAdmin && !state.processingCookie) {
    window.location.href = "/";
  }
  return (
    <>
      {state.processingCookie === true ? (
        <>Loading...</>
      ) : (
        <>
          {state.user.isAdmin && (
            <ValidatorForm
              onKeyPress={(event: any) => {
                if (event.which === 13) {
                  event.preventDefault();
                }
              }}
              onSubmit={submit}
            >
              <Container className="mt-3">
                <Paper elevation={2} className="paper">
                  <Grid container spacing={2} style={{ padding: "10px" }}>
                    <Grid item xs={12}>
                      <h2>
                        <span className="primary-color">
                          {localState.params === "add" ? "Add " : "Edit "}
                        </span>
                        <span className="secondary-color">Publication </span>
                      </h2>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Tooltip
                        title={"Title of publication"}
                        placement="top"
                        arrow
                      >
                        <TextValidator
                          fullWidth={true}
                          label="Title"
                          onChange={handleInputChange}
                          name="title"
                          value={publicationData.title || ""}
                          validators={["required"]}
                          errorMessages={["This field is required"]}
                          variant="outlined"
                        />
                      </Tooltip>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Tooltip title={"Authors"} placement="top" arrow>
                        <TextValidator
                          fullWidth={true}
                          label="Authors"
                          onChange={handleInputChange}
                          name="authors"
                          value={publicationData.authors || ""}
                          validators={["required"]}
                          errorMessages={["This field is required"]}
                          variant="outlined"
                        />
                      </Tooltip>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <Tooltip
                        title={"Journal of publication"}
                        placement="top"
                        arrow
                      >
                        <TextValidator
                          fullWidth={true}
                          label="Journal"
                          onChange={handleInputChange}
                          name="journal"
                          value={publicationData.journal || ""}
                          validators={["required"]}
                          errorMessages={["This field is required"]}
                          variant="outlined"
                        />
                      </Tooltip>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Tooltip title={"Editors"} placement="top" arrow>
                        <TextValidator
                          fullWidth={true}
                          label="Editors"
                          onChange={handleInputChange}
                          name="editors"
                          value={publicationData.editors || ""}
                          variant="outlined"
                        />
                      </Tooltip>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <Tooltip title={"Publisher"} placement="top" arrow>
                        <TextValidator
                          fullWidth={true}
                          label="Publisher"
                          onChange={handleInputChange}
                          name="publisher"
                          value={publicationData.publisher || ""}
                          variant="outlined"
                        />
                      </Tooltip>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Tooltip title={"Publisher place"} placement="top" arrow>
                        <TextValidator
                          fullWidth={true}
                          label="Publisher Place"
                          onChange={handleInputChange}
                          name="publisher_place"
                          value={publicationData.publisher_place || ""}
                          variant="outlined"
                        />
                      </Tooltip>
                    </Grid>

                    <Grid item xs={12} sm={2}>
                      <Tooltip
                        title={"Year of publication"}
                        placement="top"
                        arrow
                      >
                        <TextValidator
                          fullWidth={true}
                          label="Year"
                          onChange={handleInputChange}
                          name="year"
                          value={publicationData.year || ""}
                          variant="outlined"
                        />
                      </Tooltip>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                      <Tooltip title={"Volume"} placement="top" arrow>
                        <TextValidator
                          fullWidth={true}
                          label="Volume"
                          onChange={handleInputChange}
                          name="volume"
                          value={publicationData.volume || ""}
                          variant="outlined"
                        />
                      </Tooltip>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                      <Tooltip title={"Pages"} placement="top" arrow>
                        <TextValidator
                          fullWidth={true}
                          label="Pages"
                          onChange={handleInputChange}
                          name="pages"
                          value={publicationData.pages || ""}
                          variant="outlined"
                        />
                      </Tooltip>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Tooltip
                        title={"DOI of publication"}
                        placement="top"
                        arrow
                      >
                        <TextValidator
                          fullWidth={true}
                          label="DOI"
                          onChange={handleInputChange}
                          name="doi"
                          value={publicationData.doi || ""}
                          variant="outlined"
                        />
                      </Tooltip>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <Multiselect
                        options={state.filters}
                        groupBy="tag_type_name"
                        displayValue="tag_name"
                        showCheckbox={true}
                        onSelect={onChangeDropdownList}
                        onRemove={onChangeDropdownList}
                        closeOnSelect={false}
                        placeholder="Keywords"
                        style={multiselectDesign}
                        selectedValues={publicationData.book_tags_models}
                      />
                    </Grid>

                    <Grid className="form-submit-button" item xs={12}>
                      <Button type="submit" color="primary" variant="contained">
                        {localState.params === "add" ? "Insert" : "Update"}
                      </Button>{" "}
                      {localState.params === "add" ? (
                        <>
                          <Button
                            onClick={() => {
                              window.location.href = "/";
                            }}
                            color="secondary"
                            variant="contained"
                          >
                            Cancel{" "}
                          </Button>
                        </>
                      ) : (
                        <>
                          <Button
                            onClick={() => {
                              thisDeletePublication(localState.params);
                            }}
                            color="secondary"
                            variant="contained"
                          >
                            Delete{" "}
                            <CircularProgress
                              style={{
                                marginLeft: "5px",
                                display: isDeleting ? "block" : "none",
                              }}
                              size={20}
                              color="inherit"
                            />
                          </Button>
                        </>
                      )}
                    </Grid>
                  </Grid>
                </Paper>
              </Container>
            </ValidatorForm>
          )}
        </>
      )}
    </>
  );
};

export default Publication;
